import React from 'react';
import PropTypes from 'prop-types';
import {Col, Form, Row} from 'react-bootstrap';
import Select from '../Select/Select';
import Translate from '../Translate/Translate';

function TimeIntervalInput({
    field,
    unit,
    classes,
    inputProps,
    onChange,
    onBlur
}) {
    //sst: select props and time interval field value
    let selectProps = {};
    let fieldData = field.value || { value: '', unit: '' };

    //sst: handle on change label
    selectProps.onChange = selected => {
        //sst: handle clear selection
        if (Array.isArray(selected)) {
            onChange(field.internalName, '');
            return onBlur(field.internalName, null);
        }
        fieldData.unit = selected.value;
        if (fieldData.value === '') fieldData.value = 0;
        onChange(field.internalName, fieldData);
        onBlur(field.internalName, fieldData);
    };

    //sst: handle on change input data
    inputProps.onChange = e => {
        fieldData.value = e.target.value || 0;
        if (fieldData.unit === '') fieldData.unit = unit[0].value;
        onChange(field.internalName, fieldData);
    };

    inputProps.onBlur = e => {
        onBlur(field.internalName, fieldData);
    };

    //sst: field input props
    inputProps = {
        ...inputProps,
        min: 0,
        maxLength: 5,
        type: 'number',
        value: field.value ? field.value.value : '',
        placeholder: 'value',
        className: 'form-control'
    };

    //sst: select unit by stored value
    if (fieldData && unit) {
        selectProps.value = unit.filter(x => x.value === fieldData.unit);
    }

    return (
        <Row>
            <Col md={3} className={'pe-0'}>
                <Form.Control {...inputProps} />
            </Col>
            <Col md={9}>
                <Select
                    className={classes}
                    options={unit}
                    placeholder={<Translate message="Select unit" />}
                    isClearable={true}
                    {...selectProps}
                />
            </Col>
        </Row>
    );
}

TimeIntervalInput.defaultProps = {
    inputProps: {}
};

TimeIntervalInput.propTypes = {
    field: PropTypes.object,
    unit: PropTypes.array,
    classes: PropTypes.array,
    inputProps: PropTypes.object,
    onChange: PropTypes.func
};

export default TimeIntervalInput;
